import { useMemo } from 'react';

import { DataHubTab } from '@/pages/DataHub/types';

/**
 * Custom hook to manage DataHub tabs
 *
 * @param disabled Whether tabs should be disabled
 * @returns Array of DataHub tabs with their state
 */
const useDataHubTabs = (disabled: boolean): DataHubTab[] => {
  return useMemo(
    () => [
      { name: 'Summary', disabled },
      { name: 'Preview', disabled },
      { name: 'Chart', disabled },
      { name: 'Export', disabled }
    ],
    [disabled]
  );
};

export default useDataHubTabs;
